import { useCallback, useState } from 'react'
import { DEFAULT_LIBRARY_FILTERS } from '../constant'

export function useLibraryFilters() {
  const [search, setSearch] = useState(DEFAULT_LIBRARY_FILTERS.search)
  const [sort, setSort] = useState(DEFAULT_LIBRARY_FILTERS.sort)
  const [ratios, setRatios] = useState(DEFAULT_LIBRARY_FILTERS.ratios)
  const [clearSearchQuery, setClearSearchQuery] = useState(false)

  const handleSearch = useCallback((value) => {
    setSearch(value || '')
  }, [])

  const handleSortChange = useCallback((sortKey) => {
    setSort((currentSort) => (currentSort === sortKey ? null : sortKey))
  }, [])

  const handleRatioChange = useCallback((ratioKey) => {
    setRatios((currentRatios) => (
      currentRatios.includes(ratioKey)
        ? currentRatios.filter((ratio) => ratio !== ratioKey)
        : [...currentRatios, ratioKey]
    ))
  }, [])

  const handleFilterReset = useCallback(() => {
    setSort(DEFAULT_LIBRARY_FILTERS.sort)
    setRatios(DEFAULT_LIBRARY_FILTERS.ratios)
  }, [])

  const reset = useCallback(() => {
    setSearch(DEFAULT_LIBRARY_FILTERS.search)
    setSort(DEFAULT_LIBRARY_FILTERS.sort)
    setRatios(DEFAULT_LIBRARY_FILTERS.ratios)
    setClearSearchQuery(true)
  }, [])

  return {
    search,
    sort,
    ratios,
    handleSearch,
    handleSortChange,
    handleRatioChange,
    handleFilterReset,
    reset,
    clearSearchQuery,
    setClearSearchQuery,
  }
}
